import "../styles/Collection.css";
import { useContext } from "react";
import { EthereumContext } from "./Layout";
import { ethers } from "ethers";
import React, { useState, useEffect } from "react";

function Collection() {
  let { userAccount, contract } = useContext(EthereumContext);
  const [rerolls, setRerolls] = useState(0);
  const [tokenIds, setTokenIds] = useState([]);
  const [tokenURIs, setTokenURIs] = useState([]);
  const [rerollQuantitiesAndPrices, setRerollQuantitiesAndPrices] = useState([
    [],
  ]);
  const [selectedReroll, setSelectedReroll] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [userPrompt, setUserPrompt] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  async function retrieveRolls() {
    if (contract == null || userAccount == null) {
      setRerolls(0);
    } else {
      let rerollCount = await contract.rerolls(userAccount);
      setRerolls(rerollCount.toString());
    }
  }

  useEffect(() => {
    retrieveRolls();
  }, [contract, userAccount]);

  useEffect(() => {
    async function getRerollsQuantitiesAndPrices() {
      if (contract) {
        const length = await contract.getRerollQuantitiesLength();
        let rerollsAndPrices = [];
        for (let i = 0; i < length; i++) {
          const quantity = await contract.rerollQuantities(i);
          const priceData = await contract.rerollPriceData(quantity);

          if (priceData.currency == 1) {
            const maticPrice = Number(await contract.getLatestMaticUsdData());
            let price =
              Math.ceil((Number(priceData.price) * maticPrice) / 1e35) / 10;
            rerollsAndPrices.push([Number(quantity), Number(price)]);
          } else {
            rerollsAndPrices.push([Number(quantity), Number(priceData.price)]);
          }
        }
        setRerollQuantitiesAndPrices(rerollsAndPrices);

        if (rerollsAndPrices.length > 0) {
          setSelectedReroll(rerollsAndPrices[0][0]);
        }
      }
    }

    getRerollsQuantitiesAndPrices();
  }, [contract, userAccount]);

  useEffect(() => {
    async function retrieveTokens() {
      if (contract && userAccount) {
        const totalTokens = await contract.balanceOf(userAccount);
        const ids = [];
        for (let i = 0; i < totalTokens; i++) {
          const tokenId = await contract.tokenOfOwnerByIndex(userAccount, i);
          ids.push(tokenId.toString());
        }
        setTokenIds(ids);
      }
    }
    retrieveTokens();
  }, [contract, userAccount]);
  useEffect(() => {
    fetchURIs();
  }, [contract, tokenIds]);
  async function fetchURIs() {
    if (contract && tokenIds.length > 0) {
      const uris = [];
      for (let id of tokenIds) {
        let uri = await contract.tokenURI(id);
        uri = uri.toString();

        // Fetch the metadata JSON from the URI
        const response = await fetch(uri);
        if (!response.ok) {
          console.error(
            `Failed to fetch metadata for token ${id}: ${response.statusText}`
          );
          continue;
        }

        const metadata = await response.json();

        // Extract the image URL from the metadata
        const imageUrl = metadata.image;
        uris.push(imageUrl);
      }
      setTokenURIs(uris);
    } else if (tokenIds.length == 0) {
      setTokenURIs([]);
    }
  }
  async function buyRerolls() {
    try {
      /*if (!selectedReroll || isNaN(parseInt(selectedReroll)))*/
      if (!userAccount) {
        alert("Please connect your wallet");
        return;
      }
      let quantity = parseInt(selectedReroll);
      let quantityPrice = await contract.getRerollPrice(quantity);
      const overrides = {
        value: quantityPrice,
      };
      let tx = await contract.buyRerolls(userAccount, quantity, overrides);
      await tx.wait();
      retrieveRolls();
      console.log("Reroll purchase was successful!");
    } catch (error) {
      console.log(error);
    }
  }

  const handleRerollChange = (event) => {
    setSelectedReroll(event.target.value);
  };

  function handleRerollClick() {
    setShowDialog(true);
  }

  function handleUriChange(tokenId) {
    // After submitting the prompt, start checking for token URI changes
    const checkInterval = 5000; // Check every 5 seconds
    const totalCheckTime = 300000; // Check for a total of 300 seconds
    let checkCount = 0;

    const intervalId = setInterval(async () => {
      // If we've checked for the total check time, stop checking
      if (checkCount * checkInterval >= totalCheckTime) {
        clearInterval(intervalId);
        return;
      }

      // Get the current token URI
      const currentTokenURI = await contract.tokenURI(selectedImage);

      // If the token URI has changed, fetch the URIs again
      if (tokenURIs[selectedImage] !== currentTokenURI) {
        fetchURIs();
      }

      checkCount++;
    }, checkInterval);
  }
  async function handleSubmitPrompt() {
    try {
      if (!contract || !userAccount) {
        alert("Please connect to the network first.");
        return;
      }
      let tx = null;
      triggerCloudFunction();
      if (userPrompt.length == 0) {
        setUserPrompt("random");
        tx = await contract.submitPrompt(selectedImage, "random");
      } else {
        tx = await contract.submitPrompt(selectedImage, userPrompt);
      }
      await tx.wait();
      setShowDialog(false); // Close the dialog upon success.
      retrieveRolls(); // Update the rerolls.
      console.log("Prompt submitted successfully!");
      handleUriChange(selectedImage);
    } catch (error) {
      console.error("Error submitting prompt:", error.message);
    }
  }

  async function triggerCloudFunction() {
    try {
      const response = await fetch(
        "https://us-central1-promptmeister-41fdd.cloudfunctions.net/listenToContractEvent",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Origin: "https://promptmeister-41fdd.web.app",
          },
          // You can send any necessary data to the function here
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to trigger Cloud Function");
      }

      const data = await response.text();
      console.log("Cloud Function response:", data);
    } catch (error) {
      console.error("Error triggering Cloud Function:", error.message);
    }
  }

  return (
    <div className="container-collection">
      <div className="collection one">
        <div className="reroll-container">
          <h3 id="rerolls-owned">REROLLS OWNED: {rerolls}</h3>
          <button id="reroll-buy" onClick={buyRerolls}>
            PURCHASE REROLLS
          </button>

          <select
            id="reroll-prices"
            title="REROLL PRICES"
            onChange={handleRerollChange}
          >
            {rerollQuantitiesAndPrices.map(([quantity, price], index) => (
              <option key={index} value={quantity}>
                {quantity} REROLL{quantity > 1 ? "S" : ""} - ${price}
              </option>
            ))}
          </select>
        </div>
        <div className="userTokensContainer">
          {tokenURIs.map((uri, index) => (
            <div key={index} className="usertoken">
              <img
                src={uri}
                alt={`Token ${tokenIds[index]}`}
                onClick={() => setSelectedImage(tokenIds[index])}
              />
              {selectedImage === tokenIds[index] && (
                <button onClick={handleRerollClick}>
                  Reroll image with prompt
                </button>
              )}
              <span>Token ID: {tokenIds[index]}</span>
            </div>
          ))}
        </div>
      </div>
      {showDialog && (
        <div className="dialog">
          <div className="dialog-content">
            <h2>Enter a prompt</h2>
            <input
              type="text"
              value={userPrompt}
              onChange={(e) => setUserPrompt(e.target.value)}
            />
            <button onClick={handleSubmitPrompt}>Submit</button>
            <button onClick={() => setShowDialog(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
export default Collection;
